import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Employee } from '../../../domain/employees/employee';
import { EmployeesRepository } from '../../../infrastructure/repositories/employees/employeeRepository';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { Private_Routes } from '../../../main/constants';
import { AppContext } from '../../../main/context/Provider';
import { EmployeeForm } from '../components/form/EmployeeForm';

export const UpdateEmployeePage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const [employee, setEmployee] = useState<Employee>();
    const { id } = useParams<{ id: string }>();

    const { webPage } = changeWebPageTitleService(
        isSkinSmart,
        'Actualizar Empleado'
    );

    useEffect(() => {
        if (id) {
            EmployeesRepository.GetEmployee(id).then((response) =>
                setEmployee(response)
            );
        }
    }, [id]);

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Empleados',
                route: Private_Routes.EMPLOYEE_PAGE,
            },
            {
                label: webPage,
                route: Private_Routes.UPDATE_EMPLOYEE_PAGE,
            },
        ]);
    }, [lang]);

    return (
        <>
            {employee != null && (
                <EmployeeForm isNewEmployee={false} employee={employee} />
            )}
        </>
    );
};
